import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import ReroutingToOpenMarketplace from './ReroutingToOpenMarketplace.vue';
    import {computed, ref} from 'vue';
    import {useStore} from 'vuex';
    import {useTranslation} from '@malt/vue3-use';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import {ProfileCategory, ProfileFamily} from '@/common/api/api-raw-types';
    import {inject} from 'vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ReroutingToOpenMarketplaceCategory',
  emits: ["category-rerouting"],
  setup(__props, { emit: __emit }) {

    const trackingRepository = inject(DI.trackingRepository);
    const store = useStore();
    const {msg} = useTranslation();
    const creationForm = ref(store.getters[getters.creationForm]);
    const allFamiliesSelectable = computed(() => store.getters[getters.allFamiliesSelectable]);
    const eligibleCategories = computed(() => {
        return allFamiliesSelectable.value
            .flatMap((profileFamily: ProfileFamily) => profileFamily.categories.filter((category) => category.verticals.includes('STRATEGY')))
            .map((category: ProfileCategory) => category.categoryId);
    });

    const emit = __emit;

    const isVisible = computed(() => {
        const selectedCategories = creationForm.value.familiesCategoriesEdition.allSelectedCategories();
        const hasIneligibleCategories = selectedCategories.some((selectedCategory) => !eligibleCategories.value.includes(selectedCategory));
        const hasOtherCategorySelected = creationForm.value.familiesCategoriesEdition.suggestedCategory() != null;
        const shouldBeRedirected = hasIneligibleCategories || hasOtherCategorySelected;
        emit('category-rerouting', shouldBeRedirected);
        return shouldBeRedirected;
    });

    const trackReroute = function () {
        trackingRepository?.track('funnel-redirection-strategy', {
            reason: 'category',
        });
    };

return (_ctx: any,_cache: any) => {
  return (isVisible.value)
    ? (_openBlock(), _createBlock(ReroutingToOpenMarketplace, {
        key: 0,
        "data-testid": "rerouting-to-open-marketplace",
        title: _unref(msg)('profile.creation.wizard.strategy.categorization.rerouting.message.selectedCategoryNotEligible.title'),
        line1: _unref(msg)('profile.creation.wizard.strategy.categorization.rerouting.message.selectedCategoryNotEligible.line1'),
        line2: _unref(msg)('profile.creation.wizard.strategy.categorization.rerouting.message.selectedCategoryNotEligible.line2'),
        onRerouteToMarketplace: _cache[0] || (_cache[0] = ($event: any) => (trackReroute()))
      }, null, 8, ["title", "line1", "line2"]))
    : _createCommentVNode("", true)
}
}

})